import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom'
import { HashLink as Link } from 'react-router-hash-link'

class Footer extends Component {
    mapItems = dataArr => (
        dataArr.map((val, key) => (
            <NavLink
                key={key}
                to={val.path}
                className="footer-nav-items__item"
                activeClassName="footer-nav-items__item--active"
                exact
            >
                <span className="footer-nav-items__item-text">{val.title}</span>
            </NavLink>
        ))
    )

    mapItemsHash = dataArr => (
        dataArr.map((val, key) => (
            <Link
                key={key}
                to={val.path}
                className="footer-nav-items__item"
            >
                <span className="footer-nav-items__item-text">{val.title}</span>
            </Link>
        ))
    )

    render() {
        return (
            <div className="footer">
                <img
                    className="footer-bck-img"
                    src="/images/bck/bed_footer.png"
                />
                <div className="footer-container">
                    <div className="container-fluid">
                        <div className="row footer-row">
                            <div className="col-md-5 hidden-sm hidden-xs">
                                <div className="footer-logo">
                                    <img
                                        className="footer-logo__img"
                                        src="/images/ico/bed_logofooter.png"
                                    />
                                    <div className="footer-logo__text">
                                        <span>
                                            Copyright Bedrina Projekt d.o.o. 2017. All rights reserved
                                        </span>
                                    </div>
                                    <div>
                                        <a
                                            className="alt-footer"
                                            href="http://altdev.hr"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <span className="alt-footer__title">
                                                Built with passion by ALT
                                            </span>
                                            <img
                                                className="alt-footer__img"
                                                src="/images/ico/munja.png"
                                                alt="alt"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-xs-6">
                                <div className="footer-nav">
                                    <span className="footer-nav__title">
                                        {this.props.langData.footer.navTitle}
                                    </span>
                                    <div className="footer-nav-items">
                                        {this.mapItems(this.props.langData.header)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-xs-6">
                                <div className="footer-nav footer-nav--mobile">
                                    <span className="footer-nav__title">
                                        {this.props.langData.footer.findOutMoreTitle}
                                    </span>
                                    <div className="footer-nav-items">
                                        {this.mapItemsHash(this.props.langData.footer.findOutMore)}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-6">
                                <span className="footer-nav__title">
                                    {this.props.langData.footer.connectTitle}
                                </span>
                                <div className="footer-connect__icon">
                                    <a
                                        href="https://web.facebook.com/BedrinaProjekt/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            className="social-item__img social-item__img--footer"
                                            src="/images/ico/bed_footer_facebook.png"
                                        />
                                    </a>
                                </div>
                                <div className="footer-connect__icon">
                                    <a
                                        href="https://www.instagram.com/gbedrina/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            className="social-item__img social-item__img--footer"
                                            src="/images/ico/bed_footer_instagram.png"
                                        />
                                    </a>
                                </div>
                                <div className="footer-connect__icon">
                                    <a
                                        href="https://linkedin.com/in/goran-bedrina-30a36345"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            className="social-item__img social-item__img--footer"
                                            src="/images/ico/bed_footer_linkedin.png"
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-sm-6 col-xs-6 hidden-md hidden-lg hidden-xl">
                                <div className="footer-logo">
                                    <img
                                        className="footer-logo__img"
                                        src="/images/ico/bed_logofooter.png"
                                    />
                                    <div className="footer-logo__text">
                                        <span>
                                            Copyright Bedrina Projekt d.o.o. 2017. All rights reserved
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="alt-footer-resp hidden-lg hidden-md hidden-xl">
                                <a
                                    className="alt-footer"
                                    href="http://altdev.hr"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className="alt-footer__title">
                                        Built with passion by ALT
                                    </span>
                                    <img
                                        className="alt-footer__img"
                                        src="/images/ico/munja.png"
                                        alt="alt"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData
})

export default withRouter(connect(mapStateToProps)(Footer))



// WEBPACK FOOTER //
// ./src/scripts/containers/Footer.jsx